<template>
  <modal :show.sync="dialogDeleteContentNoteStore.show" type="mini" :show-header="false">
    <h4 style="text-align: center">
      Do you want to delete the message?
    </h4>
    <div style="text-align: center">
      <div style="margin-left: auto; margin-right: auto">
        <p-button round type="success" text @click="deleteContentNote" style="margin: 10px">
          Yes
        </p-button>
        <p-button round text @click="closeDialog" style="margin: 10px">
          Cancel
        </p-button>
      </div>
    </div>
  </modal>
</template>

<script>
import store from '@/store/index.js'
import { Modal } from '@/components/UIComponents'
import { mapGetters } from 'vuex'

export default {
  name: 'DialogDeleteContentNote',
  components: { Modal },
  computed: { 
    ...mapGetters(['dialogDeleteContentNoteStore'])
  },
  methods: {
    closeDialog() {
      store.commit('closeDialogDeleteContentNote')
    },
    deleteContentNote() {
      const note = this.dialogDeleteContentNoteStore.note
      const data = this
      store.dispatch('updateContentNote', {
        contentId: note.contentId,
        noteId: note.noteId,
        text: note.text,
        status: 'archived'
      }).then(() => {
        data.closeDialog()
      })
    }
  }
}
</script>